import Moment from 'moment/moment';

// paid_date is a DateTimeField; pin the picked calendar date to UTC noon so it round-trips as the same day in every timezone.
export const toPaidDate = (value: any) => (value && Moment(value).isValid() ? new Date(`${Moment(value).format('YYYY-MM-DD')}T12:00:00Z`) : null);
